import { Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import { Card, CardPaycodeRegister, DataList, Vendor } from '@shared/models';

import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class CardService {
  constructor(private apiService: ApiService) {}

  actives(country_code: string | null = null): Observable<DataList<Card>> {
    if (country_code) {
      return this.apiService.get<DataList<Card>>('user/cards?active=1&country_code=' + country_code).pipe();
    }
    return this.apiService.get<DataList<Card>>('user/cards?active=1').pipe();
  }

  list(country_code: string | null = null): Observable<DataList<Card>> {
    if (country_code) {
      return this.apiService.get<DataList<Card>>('user/cards?country_code=' + country_code).pipe();
    }
    return this.apiService.get<DataList<Card>>('user/cards').pipe();
  }

  register(token: string): Observable<{ message: string }> {
    return this.apiService.post<{ message: string }>('user/cards', { token_stripe_id: token }).pipe();
  }

  registerPaycode(cardData: CardPaycodeRegister): Observable<{ message: string }> {
    return this.apiService.post<{ message: string }>('user/cards', cardData).pipe();
  }

  main(id: string): Observable<{ message: string }> {
    return this.apiService.put<{ message: string }>('user/cards/' + id + '/main', {}).pipe();
  }

  delete(id: string): Observable<{ message: string }> {
    return this.apiService.delete<{ message: string }>('user/cards/' + id).pipe();
  }

  active(id: string, amount: number): Observable<{ message: string }> {
    return this.apiService.put<{ message: string }>('user/cards/' + id + '/active', { amount: amount }).pipe();
  }

  vendors(country_code: string | null = null): Observable<DataList<Vendor>> {
    if (country_code) {
      return this.apiService.get<DataList<Vendor>>('user/vendors?country_code=' + country_code).pipe();
    }
    return this.apiService.get<DataList<Vendor>>('user/vendors').pipe();
  }
}
